import type { AdtraceInitOptions, Env, LogLevel } from "src/types/adtrace";

let inited = false;
let AdtraceRef: any | null = null;

function getEnv<K extends string>(key: K) {
  return import.meta.env[key as any] as string | undefined;
}

// Just once init
export async function initAdtrace(overrides: Partial<AdtraceInitOptions> = {}) {
  if (typeof window === "undefined") return;
  if (inited || (window as any).__adtraceInited) return;

  const Adtrace =
    (window as any).Adtrace ?? (await import("web-adtrace")).default;
  AdtraceRef = Adtrace;

  const appToken = getEnv("VITE_ADTRACE_APP_TOKEN");
  const environment =
    (getEnv("VITE_ADTRACE_ENV") as Env) ||
    (import.meta.env.PROD ? "production" : "sandbox");

  if (!appToken) {
    if (!import.meta.env.PROD) {
      console.warn(
        "[Adtrace] Missing VITE_ADTRACE_APP_TOKEN; not initialized."
      );
    }
    return;
  }

  const opts: AdtraceInitOptions = {
    appToken,
    environment,
    namespace: getEnv("VITE_ADTRACE_NAMESPACE"),
    logLevel:
      (getEnv("VITE_ADTRACE_LOG_LEVEL") as LogLevel) ||
      (environment === "sandbox" ? "verbose" : "error"),
    attributionCallback: (_e, attribution) => {
      if (!import.meta.env.PROD) {
        console.log("[Adtrace] Attribution changed", attribution);
      }
    },
    ...overrides,
  };

  Adtrace.initSdk(opts);
  inited = true;
  (window as any).__adtraceInited = true;
}

export function setAdtraceExternalId(externalDeviceId?: string) {
  if (!externalDeviceId) return;
  const A = AdtraceRef || (window as any).Adtrace;
  if (!A) return;

  if (typeof A.setExternalDeviceId === "function") {
    A.setExternalDeviceId(String(externalDeviceId));
    return;
  }

  if (typeof A.addSessionCallbackParameter === "function") {
    A.addSessionCallbackParameter(
      "external_device_id",
      String(externalDeviceId)
    );
  }
}

export async function initAdtraceWithExternalId(externalDeviceId?: string) {
  await initAdtrace();
  setAdtraceExternalId(externalDeviceId);
}
